import { render, staticRenderFns } from "./ComentariosGuardados.vue?vue&type=template&id=081a9abc&scoped=true&"
import script from "./ComentariosGuardados.vue?vue&type=script&lang=js&"
export * from "./ComentariosGuardados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081a9abc",
  null
  
)

export default component.exports